/** Column header labels for the Case Appeals table. */
export enum CaseAppealsTableHeaderLabels {
  DATE_OF_WORK = "DOW",
  PATIENT_NAME = "Patient Name",
  DOB = "DOB",
  DRUG = "Drug",
  COVER_MY_MEDS_ID = "CoverMyMeds ID",
  SECOND_STP_STATUS = "Second STP Status",
  RESPONSE_STATUS = "Response Status",
  CASE_ID = "Case ID",
  POC = "POC",
  CASE_STATUS = "Case Status",
  APPEAL_PROBABILITY = "Appeal Probability",
  ACTION = "Action",
  NEXT_FOLLOW_UP = "Next Follow Up",
  HISTORY_ICON = "",
}

export { CaseAppealsTableColumnKeys } from "../../../enums/tableColumnKeys";
